import { Main } from "../../styled";
import { TermosContainer } from "./styled";
import logo from '../../../../assets/logo_plantando.png';


function Termos() {

  return (
    <Main>
      <TermosContainer>

        <div className="content">
          <img src={logo} className="image"/>
          <h1>Termos e Condições de Uso</h1>
          <br />

          <p>Este Termo se aplica aos Usuários do Site e do Aplicativo Geoplantio, de razão social TUBISHVAT COMERCIO E SERVICOS LTDA (Geoplantio) e tem as seguintes finalidades:</p>

          <br />

          - Regular a relação contratual entre a Geoplantio e os clientes que utilizam o Site e Aplicativo (“Usuários”);
          <br />
          <br />
          <p className="tab">
            – Estabelecer as regras de utilização da Plataforma Digital da Geoplantio e as responsabilidades da Geoplantio e dos Usuários, em conformidade com a legislação brasileira, incluindo, mas não se limitando às disposições das seguintes leis:
            <br />
            <br />
            <ul className='tab'>
              <li> Código de Defesa do Consumidor;</li>
              <li> Marco Civil da Internet;</li>
              <li> Decreto no 8.771/2016.</li>
            </ul>
          </p>

          <br />

          <p>Caso você não concorde com este Termo ou algum ponto não tenha ficado claro, recomendamos que
            você NÃO UTILIZE este Aplicativo. Você poderá ainda, a qualquer tempo, retornar ao site, clicar em
            Termos de Uso e reler este documento quantas vezes desejar.</p>

          <br />

          <p className='tab'><b>
            <p>CNPJ: 48.567.170/0001-89</p>
            <p>Endereço: Endereço SERAFIM DERENZI, 1810D - PAVMTO3 - SAO CRISTOVAO - CEP: 29048515 Vitoria/ES</p>
          </b></p>

          <br />

          <p>A <b>Geoplantio</b> é uma plataforma que conecta plantadores por meio de grupos e fóruns, facilitando a troca de conhecimento e experiências. Além disso, pelo APP Geoplantio, os usuários podem gerenciar seus plantios de forma eficiente.</p>

          <br />
          <p>O Aplicativo da <b>Geoplantio</b> é destinado a todos os usuários, sem restrição de idade ou necessidade de documentos.</p>
          <br />

          <p>Ao concordar com este Termo, o Usuário se compromete a:</p>
          <ul className='tab'>
            <li>O Usuário obterá acesso na Plataforma Digital através de login e senha;</li>
            <li>Manter a Plataforma Digital em pleno funcionamento, garantindo o acesso ao App e ao Site;</li>
            <li>Assegurar a privacidade das informações fornecidas pelos Usuários;</li>
            <li>Qualquer Usuário que desrespeitar a legislação aplicável ou as obrigações aqui previstas estará sujeito ao cancelamento de seu cadastro na Plataforma Digital e à perda do direito de uso do Site e do App, sem prejuízo de responder civil e criminalmente pelas consequências de seus atos e/ou omissões;</li>
            <li>O App Geoplantio se reserva no direito de investigar e excluir todos os perfis pertencentes a Usuários infratores da lei ou das regras aqui previstas, mantendo, em seu banco de dados, as informações constantes nos perfis de seus Usuários, mesmo após o cancelamento, a fim de instruir eventual investigação e/ou processo judicial, e a seu critério, notificar, suspender ou cancelar o cadastro do Usuário, a qualquer tempo, definitiva ou temporariamente, nos seguintes casos:</li>
            <ul className='tab'>
              <li>Descumprimento de qualquer disposição deste Termo;</li>
              <li>Não cumprimento de quaisquer de suas obrigações;</li>
              <li>Verificação de cadastro duplicado;</li>
              <li>Constatação de fraude ou tentativa de fraude;</li>
              <li>Fornecimento incorreto de informações solicitadas, inverídicas ou que se negar a prestar eventuais informações adicionais solicitadas;</li>
              <li>Tentativa de violar os sistemas ou o banco de dados.</li>
            </ul>
          </ul>


          <p>Os elementos ou ferramentas encontradas no Site e no Aplicativo são de titularidade ou licenciados pelo
            App, sujeitos à proteção dos direitos de propriedade intelectual de acordo com as leis brasileiras e tratados
            e convenções internacionais dos quais o Brasil seja signatário. Apenas a título exemplificativo, entendem-
            se como tais: textos, softwares, scripts, imagens gráficas, fotos, sons, músicas, vídeos, recursos interativos
            e similares, marcas, marcas de serviços, logotipos etc.Os elementos ou ferramentas encontradas no Site e no Aplicativo são de titularidade ou licenciados pelo App, sujeitos à proteção dos direitos de propriedade intelectual de acordo com as leis brasileiras e tratados e convenções internacionais dos quais o Brasil seja signatário. Apenas a título exemplificativo, entendem-se como tais: textos, softwares, scripts, imagens gráficas, fotos, sons, músicas, vídeos, recursos interativos e similares, marcas, marcas de serviços, logotipos etc.</p>
          <br />

          <p>A Plataforma Digital pode conter links para sites ou aplicativos operados por terceiros que não são controlados pela Geoplantio, não sendo este responsável pela sua disponibilidade e/ou pelo seu conteúdo.
          </p><br />

          <p>Este Termo será regido e interpretado de acordo com as leis brasileiras. Você, ao concordar com este Termo, submete-se incondicionalmente à jurisdição brasileira para a resolução de quaisquer disputas;
          </p><br />

          <p>Este Termo poderá ser revisado a qualquer momento. Por isso, é fundamental que os Usuários estejam atentos a essas alterações;</p><br />

          <p>A Plataforma Digital poderá alterar seus Termos sem qualquer notificação ou consentimento prévio necessário dos Usuários;
          </p><br />

          <p>Este Termo, e quaisquer outras políticas divulgadas, estabelecem o pleno e completo acordo e entendimento entre a Plataforma Digital e o Usuário, superando e revogando todos e quaisquer entendimentos, propostas, acordos, negociações e discussões havidos anteriormente entre as partes;
          </p><br />

          <p>Áreas específicas da Plataforma Digital (App ou Site) podem ser restritas ao acesso do Usuário, podendo se estender ainda mais essa restrição a qualquer momento e a seu exclusivo critério;
          </p><br />

          <p>
            A Plataforma Digital faz uso de cookies. Ao acessar nosso site, você concorda em usar cookies de acordo com nossas políticas.
          </p><br />

          <p>Caso a Plataforma Digital não exerça ou faça cumprir qualquer direito ou cláusula previsto neste Termo, isto não representará uma renúncia do direito, tratando-se de mera liberalidade, podendo o direito ser exigido em outra oportunidade;
          </p><br />

          <p>Na hipótese de que qualquer item, termo ou disposição deste Termo ser declarado nulo ou não aplicável, tal nulidade ou inexequibilidade não afetará quaisquer outros itens, termos ou disposições aqui contidos, os quais permanecerão em pleno vigor.
          </p><br />



          <p>Para perguntas e suporte o usuário poderá entrar em contato com a Geoplantio por meio do endereço de e-mail geoplantio@gmail.com.</p><br />
          <p>As partes elegem o Foro do Município de Vitória, no Estado do Espírito Santo, como sendo o único competente para dirimir quaisquer litígios e/ou demandas, que venham a envolver as partes em relação ao uso e acesso da Plataforma Digital através do Site e do Aplicativo.
          </p><br />

          <br />
          <p>Estes Termo é válido a partir de 19/02/2025.</p>
        </div>
      </TermosContainer>
    </Main>
  );
}

export default Termos;